import { Component, Input } from '@angular/core';
import { Location } from '../../models';

@Component({
  standalone: false,
  selector: 'mtn-address-view',
  templateUrl: './address-view.component.html',
  styleUrls: ['./address-view.component.scss']
})
export class AddressViewComponent {

  @Input()
  location: Location;

  constructor() {
  }


}
